import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";
import { FileId, initialFileState } from "./PropTypes";

export default function fileReducer(state = initialFileState, action: any) {
    const { payload } = action;
    switch (action.type) {
        case getActionType(ACTIONS.FETCH_FILES).REQUEST: {
            return {
                ...state,
                _isFetching: true
            }
        }

        case getActionType(ACTIONS.PATCH_FILE).REQUEST: {
            return {
                ...state,
                _isPatching: true
            }
        }

        case getActionType(ACTIONS.DELETE_FILE).REQUEST: {
            return {
                ...state,
                _isDeleting: true
            }
        }

        case getActionType(ACTIONS.UPLOADING_FILES).REQUEST: {
            return {
                ...state,
                _isUploading: true
            }
        }

        case getActionType(ACTIONS.FETCH_FILES).SUCCESS: {
            const { data } = payload;
            const ids: FileId[] = data.map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');

            const byEntityId: any = {};
            data.forEach((item: any) => {
                if (!byEntityId[item.entity_id]) byEntityId[item.entity_id] = [];
                byEntityId[item.entity_id].push(item.id);
            });

            return {
                ...state,
                _isFetching: false,
                _forceFetch: true,
                ids,
                entities,
                byEntityId
            }
        }

        case getActionType(ACTIONS.PATCH_FILE).SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                _isPatching: false,
                entities: {
                    ...state.entities,
                    [data.id]: data
                }
            }
        }

        case getActionType(ACTIONS.DELETE_FILE).SUCCESS: {
            const { data } = payload;

            const ids = [...state.ids].filter(i => i != data.id);
            const entities = {...state.entities};
            delete entities[data.id];

            const tempByEntityId = [ ...state.byEntityId[data.entity_id] ].filter(i => i != data.id);

            const byEntityId = {
                ...state.byEntityId
            };

            if (tempByEntityId.length == 0) {
                delete byEntityId[data.entity_id];
            } else {
                byEntityId[data.entity_id] = tempByEntityId;
            }

            return {
                ...state,
                _isDeleting: false,
                ids,
                entities,
                byEntityId
            }
        }

        case getActionType(ACTIONS.UPLOADING_FILES).SUCCESS: {
            const { data } = payload;

            const newIds = data.map(i => i.id);
            const ids = [...newIds, ...state.ids];
            const entities = {
                ...state.entities,
                ...convertArrayToObject(data, 'id')
            };

            const entity_id = data[0]?.entity_id;
            
            return {
                ...state,
                _isUploading: false,
                ids,
                entities,
                byEntityId: {
                    ...state.byEntityId,
                    [entity_id]: [
                        ...newIds,
                        ...(state.byEntityId[entity_id] || [])
                    ]
                }
            }
        }

        default:
            return { ...state };
    }
}